import { createFileRoute } from '@tanstack/react-router'
import { DocumentCreateWizard } from './components/DocumentCreateWizard'

export const Route = createFileRoute('/__auth/documents/new')({
    component: NewDocumentPage,
    staticData: { title: "routes.newDocument" }
})

function NewDocumentPage() {
    return <DocumentCreateWizard />
}
